'use strict';

var dyojCustomize = require('./dyoj/dyojCustomizePage');
var dyojCategoryPage = require('./dyoj/dyojCategoryPage');

$(document).ready(function () {
    // Initialize product tile button handlers globally (before any carousel initialization)
    dyojCustomize.handleProductTileButtons();

    // DYOJ Category Page - Load more products
    if ($('.dyoj-category-page').length) {
        dyojCategoryPage.init();
    }

    // DYOJ Customize Order
    if ($('#dyoj-customize-form').length) {
        dyojCustomize.init();
    }

    // DYOJ Landing Page - Initialize Slick Carousel
    if ($('.dyoj-landing').length && $('.dyoj-slick-carousel').length) {
        dyojCustomize.initSlickCarousel();
    }

    // DYOJ Categories Page - Initialize Slick Carousel (mobile only)
    var initCategoriesCarousel = function () {
        if ($('.dyoj-categories').length) {
            var $carousel = $('.dyoj-categories-list');
            var isMobile = $(window).width() < 1024;
            var isInitialized = $carousel.hasClass('slick-initialized');

            if (isMobile && !isInitialized) {
                // Initialize carousel only on mobile and if not already initialized
                $carousel.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    dots: false,
                    arrows: true,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 1024,
                            settings: 'unslick'
                        }
                    ]
                });
            } else if (!isMobile && isInitialized) {
                // Destroy carousel only on desktop and if initialized
                $carousel.slick('unslick');
            }
        }
    };

    initCategoriesCarousel();

    // Reinitialize on window resize with debounce to prevent multiple calls
    var resizeTimer;
    $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            initCategoriesCarousel();
        }, 250);
    });
});
